<template>
    <modal name="pEditModal" :height="'auto'" :scrollable="true" width="500">
      <div class="edit-container">
        <div class="edit-title">
          编辑你的个人资料 <i @click="$modal.hide('pEditModal')" class="close-btn"/>
        </div>
        <div class="form">
          <FormGenerator :schema="schema" :model="model" :options="formOptions"></FormGenerator>
        </div>
      </div>
    </modal>
</template>
<script>
import VueFormGenerator from "vue-form-generator"
import "vue-form-generator/dist/vfg.css"
import { request } from '../utils.js'
let validators = VueFormGenerator.validators

export default {
  props: {
    info: Object,
  },
  created:function(){
    console.log(this.info)
    //  request('guest/index/getSchoolMap')
    //     .then(res => {
    //       if(res.success) {
    //         this.schema.fields[3].values = res.data
    //       }
    //     })
  },
  components: {
    FormGenerator: VueFormGenerator.component,
  },
  methods: {
    onSubmit(e) {
      request('member/user/updateUser', this.model)
        .then(res => {
          if(res.success) {
            const {data} = res

            this.$emit('editSucess', {
              name: data.userfullname,
              gender: data.usergender,
              school: data.userschool,
              course: data.usercourse,
              isstudy: data.userisstudy,
              achievement: data.userachievement,
            })
            // this.$store.
            this.$modal.hide('pEditModal')
          }
      })
    },
  },
  watch: {
    errMessage: function (val) {
      
    }
  },
  data () {
    return {
      model: {
        userfullname: this.info.name,
        usergender: this.info.gender || 1 ,
        // userschool: this.info.schoolId,
        usercourse: this.info.course,
        userisstudy: this.info.isstudy,
        userachievement: this.info.achievement,

      },
      schema: {
        fields: [
          {
            type: 'input',
            inputType: 'text',
            label: '你的昵称',
            model: 'userfullname',
            placeholder: '请输入',
            max: 20,
            required: true,
            validator: validators.string.locale({
              fieldIsRequired: "昵称不能为空!",
              textTooBig: "长度不能超过 {1} 个字符"
            }),
          },
          {
            type: 'radios',
            label: '性别',
            model: 'usergender',
            required: true,
            values: [
              { name: "男", value:1 },
              { name: "女", value:2 },
            ],
            styleClasses: "form-radios"

          },
          {
            type: "textArea",
            label: "个人简介/乐队简介",
            model: "userachievement",
            hint: "最多200字",
            max: 200,
            placeholder: "一句话向全世界介绍你自己",
            rows: 3,
            validator: validators.string.locale({
              textTooBig: "长度不能超过 {1} 个字符"
            }),
            styleClasses: "form-textArea"
          },
         
          // {
          //   type: 'select',
          //   model: 'userschool',
          //   label: "请选择校区",
          //   values: [],
          //   selectOptions: {
          //     noneSelectedText: "请选择校区",
          //     value:'schoolId',
          //     name:'schoolName',
          //   },
          //   required: false,
          //   validator: validators.number.locale({
          //     fieldIsRequired: "请选择校区",
          //   })
          // },
          {
            type: "checklist",
            label: "参与课程（多选）",
            model: "usercourse",
            listBox: true,
            values: [
              { value: "vocal", name: "声乐"},
              { value: "piano", name: "键盘"},
              { value: "guitar", name: "吉他"},
              { value: "composition", name: "创作"},
              // { value: "master", name: "大师创作营"},
            ],
            styleClasses: "form-checklist"
          },
          // {
          //   type: 'input',
          //   label: '学习状态:',
          //   model: 'userisstudy',
          //   // styleClasses: "form-radios"

          // },
          {
            type: "submit",
            buttonText: "提交",
            validateBeforeSubmit: true,
            onSubmit:this.onSubmit,
            styleClasses: "form-submit"
          }
        ]
      },
      formOptions: {
        validateAfterChanged: true,
        validateAsync: true
      }
    }
  }
  
}
</script>
<style lang="less">
 .edit-container{
   display: flex;
   flex-flow: column;
   max-height: 100%;
   .edit-title {
     height: 60px;
     padding: 20px 16px;
     font-size: 18px;
     font-weight: bold;
     line-height: 18px;
     color: #000;
     border-bottom: 1px solid #D8D8D8;
     box-sizing: border-box;
     .close-btn {
       display: inline-block;
       width: 16px;
       height: 16px;
       float: right;
       background: url("../assets/icons/close.png") center center/cover no-repeat;
       vertical-align: text-bottom;
       cursor: pointer;
     }
   }
   .form {
     padding: 20px 40px;
     color: #666;
     placeholder {
       color: #b3b3b3;
     }
     .form-control {
        height: 34px;
        margin-top: 8px;
        color: #333;
      }
      .form-textArea .form-control{
        height: inherit;
        width: 100% !important;
      }
      .form-checklist .form-control{
        height: inherit;
        width: 100% !important;
        padding: unset;
        border: none;
        box-shadow: none;
        .list-row {
          display: inline-block;
          input {
            display: none;
          }
          label {
            display: block;
            padding: 0 12px;
            height: 32px;
            border: 1px solid #40D77E;
            border-radius: 4px;
            color:#40D77E;
            line-height: 32px;
          }
          &:not(:last-child) label{
            margin-right: 10px;
            width: 70px;
            text-align: center;
          }
          &.is-checked {
            label {
              background: #40D77E;
              color: #fff;
            }
          }
        }
      }
     .radio-list {
        label{
          position: relative;
          input {
            
            &::after {
              content: '';
              position: absolute;
              left: -1px;
              top: 3px;
              width: 15px;
              height: 15px;
              background: url('../assets/icons/radiobox.png') center/contain no-repeat, #fff;
              cursor: pointer;
            }
          }
          &.is-checked {
            input::after{
              background: url('../assets/icons/radiobox-c.png') center/contain no-repeat, #fff;
            }
          }
        }
      }
     .form-group {
       margin-bottom: 24px;
       label {
         font-weight: bold;
       }
     }
     .form-radios {
       .radio-list{
          margin-top: 10px;
          font-size: 14px;
          label {
            display: inline-block;
            margin-right: 20px;
          }
        }
     }
     .form-submit {
       margin-top: 16px;
       margin-bottom: 0;
       input {
        width: 100%;
        height: 40px;
        font-size: 16px;
        line-height: 24px;
        padding: 8px 12px;
        background: #40D77E !important;
        border: none;
        outline: none;
        color: #fff;
      }
     }
   }
 }

</style>